import request from '@/utils/request'

/**
 * 客户端在未登录的情况下就获取应用程序版本号是否更新标识，无需传入头参
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function appClientVersionControlGet(data) {
  return request({
    type: 'base',
    url: 'app/client/version/control/get',
    method: 'post',
    data
  })
}
/**
 * 添加应用版本信息
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function appVersionAdd(data) {
  return request({
    type: 'base',
    url: 'app/version/add',
    method: 'post',
    data
  })
}
/**
 * 删除应用版本信息
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function appVersionDelete(data) {
  return request({
    type: 'base',
    url: 'app/version/delete',
    method: 'post',
    data
  })
}
/**
 * 获取应用版本信息详情
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function appVersionGet(data) {
  return request({
    type: 'base',
    url: 'app/version/get',
    method: 'post',
    data
  })
}
/**
 * 应用版本信息列表(分页)
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function appVersionPageListGet(data) {
  return request({
    type: 'base',
    url: 'app/version/page/list/get',
    method: 'post',
    data
  })
}
/**
 * 编辑应用版本信息
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function appVersionUpdate(data) {
  return request({
    type: 'base',
    url: 'app/version/update',
    method: 'post',
    data
  })
}


// WEBPACK FOOTER //
// ./src/api/AppVersion.js